import { render, staticRenderFns } from "./menu-content-area.vue?vue&type=template&id=bcf30dc2&scoped=true"
import script from "./menu-content-area.vue?vue&type=script&lang=ts"
export * from "./menu-content-area.vue?vue&type=script&lang=ts"
import style0 from "./menu-content-area.vue?vue&type=style&index=0&id=bcf30dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf30dc2",
  null
  
)

export default component.exports